import React from 'react'
import * as THREE from 'three'
import TWEEN from 'tween'
import WebVR from '../WebVR'
import PropTypes from 'prop-types'
import styles from './styles.module.css'
import { EffectComposer, RenderPass, FilmPass } from 'postprocessing'

let renderer = null;

class Robot extends React.Component {

    currentState = null
    animationActive = true

    constructor(props) {
        super(props)
        this.state = {
            vr: false
        }
    }

    componentDidMount() {
        this.initScene()
        this.initLighting()
        this.initModels()
        // this.initSmoke()
    }

    getChildContext() {
        return {
            transitionTo: (newState) => {
                return this.transitionTo(newState)
            }
        };
    }

    initScene() {
        this.clock = new THREE.Clock()
        this.scene = new THREE.Scene()
        
        if (!renderer) {
            renderer = new THREE.WebGLRenderer({ 
                antialias: true , alpha: true 
            });
        }

        this.renderer = renderer;

        this.renderer.setPixelRatio(window.devicePixelRatio)
        this.renderer.setSize( window.innerWidth, window.innerHeight )
        this.renderer.toneMappingExposure = 1.0
        this.renderer.setClearColor(0x000000, 0)

        this.mount.appendChild(this.renderer.domElement)

        this.fog = new THREE.FogExp2(0x131313, 0.5)
        //this.scene.fog = this.fog

        this.camera = new THREE.PerspectiveCamera( 70, window.innerWidth/window.innerHeight, 0.1, 100 )

        this.composer = new EffectComposer(this.renderer)
        this.composer.addPass(new RenderPass(this.scene, this.camera))
        const pass = new FilmPass({
            vignette: true,
            vignetteDarkness: 1,
            vignetteOffset: 0.4,
            noiseIntensity: 0.6,
            scanlineIntensity: 0.3
        })
        pass.renderToScreen = true
        this.composer.addPass(pass)


        window.addEventListener('resize', function() {
            let width = window.innerWidth;
            let height = window.innerHeight;
            let aspect = width / height;
            
            this.camera.aspect = aspect;
            this.camera.updateProjectionMatrix()
        
            this.renderer.setSize( width, height );
        }.bind(this), false);
    }

    initLighting() {
        let pointLight = new THREE.PointLight(0xE70095);
        let pointLight2 = new THREE.PointLight(0xE70095);
        let spotLight = new THREE.SpotLight(0xE70095);
        let spotLight2 = new THREE.SpotLight(0x222222);
        let ambLight = new THREE.AmbientLight(0x111727);

        ambLight.intensity = 5;

        pointLight.position.x = -50;
        pointLight.position.y = 0;
        pointLight.position.z = 0;

        pointLight2.position.x = 50;
        pointLight2.position.y = 0;
        pointLight2.position.z = 0;

        pointLight.intensity = pointLight2.intensity = 0.15;

        spotLight.position.x = 25;
        spotLight.position.y = 200;
        spotLight.position.z = 100;

        spotLight.castShadow = true;

        spotLight.shadow.mapSize.width = 1024;
        spotLight.shadow.mapSize.height = 1024;

        spotLight.shadow.camera.near = 100;
        spotLight.shadow.camera.far = 2000;
        spotLight.shadow.camera.fov = 45;

        spotLight.intensity = 0.7;

        spotLight2.position.x = 0;
        spotLight2.position.y = 3;
        spotLight2.position.z = 50;

        spotLight2.castShadow = true;

        spotLight2.shadow.mapSize.width = 1024;
        spotLight2.shadow.mapSize.height = 1024;

        spotLight2.shadow.camera.near = 100;
        spotLight2.shadow.camera.far = 2000;
        spotLight2.shadow.camera.fov = 45;

        spotLight2.intensity = 0.5;

        this.scene.add(pointLight);
        this.scene.add(pointLight2);
        this.scene.add(spotLight);
        this.scene.add(spotLight2);
        this.scene.add(ambLight);
    }

    initModels() {
        let geometry = new THREE.PlaneGeometry(150, 150, 32, 32)
        let material = new THREE.MeshBasicMaterial( {color: 0xE70095, side: THREE.DoubleSide, wireframe: true } )
        this.plane = new THREE.Mesh( geometry, material )
        this.plane.rotation.x = -Math.PI/2
        this.plane.position.y = -1.8
        this.plane.position.z = -10

        this.scene.add( this.plane )

        let loader = new THREE.JSONLoader()
        loader.load('/massiverobot-with-screen.json', this.robotLoaded.bind(this))
    }

    initSmoke() {
        let loader = new THREE.TextureLoader()

        loader.load('https://s3-us-west-2.amazonaws.com/s.cdpn.io/95637/Smoke-Element.png', (texture) => {
            let smokeMaterial = new THREE.MeshStandardMaterial({color: 0xffffff, map: texture, transparent: true, opacity: 0.8 });
            let smokeGeo = new THREE.PlaneGeometry(300,300);
            this.smokeParticles = [];

            for (let p = 0; p < 150; p++) {
                let particle = new THREE.Mesh(smokeGeo,smokeMaterial);
                particle.position.set((Math.random()*1000)-500, (Math.random()*50) + 1, (Math.random()*1000) - 500)
                particle.rotation.z = Math.random() * 360;
                this.scene.add(particle);
                this.smokeParticles.push(particle);
            }
        })
    }

    robotLoaded(geometry, materials) {
        this.robot = new THREE.Mesh(geometry, materials)
        this.robot.position.z = -13
        this.robot.position.y = 6.1
        this.robot.scale.setScalar(1.5)
        this.scene.add(this.robot)

        if (this.afterRobotLoaded) this.afterRobotLoaded()

        new TWEEN.Tween(this.fog).to({ density: 0.07 }, 2000)
                                 .easing(TWEEN.Easing.Quadratic.Out).start()

        this.renderer.animate(this.animate.bind(this))
    }

    enableMouseLook() {
        this.mouseLook = (e) => {
            this.targetRotation = -(Math.PI/8) + (Math.PI / window.innerWidth / 4) * e.clientX
        }
        
        window.addEventListener("mousemove", this.mouseLook, false)
    }

    disableMouseLook() {
        window.removeEventListener("mousemove", this.mouseLook)
        this.mouseLook = null
    }

    transitionTo(newState) {
        return new Promise((resolve, reject) => {
            if (newState == this.currentState) return resolve()

            let transition

            if (transition = this.transitions[newState]) {
                if (this.robot) {
                    transition(resolve)
                    this.currentState = newState
                } else {
                    this.afterRobotLoaded = () => {
                        transition(resolve)
                        this.currentState = newState
                    }
                }
            } else {
                reject()
            }
        })
    }

    setVR(enabled) {
        this.renderer.vr.enabled = enabled
        this.setState({
            vr: enabled
        })
    }

    transitions = (() => {
        return {
            home: (resolve) => {
                this.setAnimation(true)

                let robot = this.robot
                let plane = this.plane
                let camera = this.camera

                let r = { y: robot.rotation.y }
                let c = { x: camera.rotation.x }

                new TWEEN.Tween(r).to({ y: 0 }, 1500).onUpdate(function() {
                    robot.rotation.y = r.y
                    plane.rotation.z = r.y
                }).easing(TWEEN.Easing.Quadratic.Out).delay(200).start()

                new TWEEN.Tween(c).to({ x: 0.37 }, 1000).onUpdate(function() {
                    camera.rotation.x = c.x
                }).easing(TWEEN.Easing.Quadratic.Out).delay(500).start()

                new TWEEN.Tween(camera.position).to({y: 0, z: 0}, 1500)
                                                .easing(TWEEN.Easing.Quadratic.Out).onComplete(() => {
                                                    this.enableMouseLook()   
                                                    this.setVR(true) 
                                                    resolve()
                                                }).start()
            },
            blog: (resolve) => {
                this.setAnimation(true)

                let robot = this.robot
                let plane = this.plane
                let camera = this.camera

                this.setVR(false)
                this.disableMouseLook()

                let r = { y: robot.rotation.y }
                let c = { x: camera.rotation.x }

                new TWEEN.Tween(r).to({ y: Math.PI }, 1500).onUpdate(function() {
                    robot.rotation.y = r.y
                    plane.rotation.z = r.y
                }).easing(TWEEN.Easing.Quadratic.Out).delay(100).start()

                new TWEEN.Tween(c).to({ x: 0.0 }, 1000).onUpdate(function() {
                    camera.rotation.x = c.x
                }).easing(TWEEN.Easing.Quadratic.In).delay(1000).start()

                new TWEEN.Tween(camera.position).to({y: 10.5, z: -10.0}, 1500)
                                                .easing(TWEEN.Easing.Quadratic.Out).delay(300)
                                                .onComplete(() => {
                                                    this.setAnimation(false)
                                                    resolve()
                                                }).start()
            },
            chest: (resolve) => {
                this.setAnimation(true)

                let robot = this.robot
                let plane = this.plane
                let camera = this.camera

                this.setVR(false)
                this.disableMouseLook()

                let r = { y: robot.rotation.y }
                let c = { x: camera.rotation.x }

                new TWEEN.Tween(r).to({ y: 0 }, 1500).onUpdate(function() {
                    robot.rotation.y = r.y
                    plane.rotation.z = r.y
                }).easing(TWEEN.Easing.Quadratic.Out).delay(100).start()

                new TWEEN.Tween(c).to({ x: 0 }, 1000).onUpdate(function() {
                    camera.rotation.x = c.x
                }).easing(TWEEN.Easing.Quadratic.Out).delay(500).start()

                new TWEEN.Tween(camera.position).to({y: 10.5, z: -5.0}, 1500)
                                                .easing(TWEEN.Easing.Quadratic.Out).delay(300)
                                                .onComplete(() => {
                                                    this.setAnimation(false)
                                                    resolve()
                                                }).start()
            }
        }
    })()

    setAnimation(anim) {
        this.animationActive = anim
    }

    animate() {
        if (this.animationActive) {
            if (this.mouseLook && this.targetRotation) {
                let deltaY = (this.targetRotation - this.robot.rotation.y) / 100.0
    
                this.robot.rotation.y += deltaY
                this.plane.rotation.z += deltaY
            }
    
            let sp = this.smokeParticles && this.smokeParticles.length
                
            if (sp) while(sp--) {
                this.smokeParticles[sp].rotation.z +=  0.003;
            }
    
            TWEEN.update()
            this.composer.render(this.clock.getDelta());
        }
    }
    
    render() {
        return  <div>
                    <div className={styles.robot} ref={(mount) => {this.mount = mount }}>
                        { this.state.vr ? <WebVR renderer={this.renderer} /> : <div /> }
                    </div>
                    {this.props.children}
                </div>
    }

}

Robot.childContextTypes = {
    transitionTo: PropTypes.func
}

export default Robot


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Robot/index.js